/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastseenonline2Inputs */



/**
* | output |
* | --- |
* | "Online" |
*
* @param {Lastseenonline2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const lastseenonline2 = /** @type {((inputs?: Lastseenonline2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastseenonline2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Online")
	if (locale === "es") return /** @type {LocalizedString} */ ("En línea")
	return /** @type {LocalizedString} */ ("В сети")
});
export { lastseenonline2 as "lastSeenOnline" }